import { getReportPeriod, getReportSubtype } from '../shared/intercomUtils';
import { getUrlParams } from '../shared/urlUtils';
import { GA, ZOG, PERIOD } from '../../constants/shared/CommonConstants';
import { getGoalSettingsPeriod } from '../../features/progress/shared/progressHelper';

const { GROWTH_ANALYSIS } = GA;
const { GOAL_SETTINGS } = ZOG;
const { BOY_EOY, FULL_YEAR } = PERIOD;

export const getD8ReportSubtype = location => {
    const { progressView } = getUrlParams(location);

    return progressView || getReportSubtype(location);
};

export const getD8ReportPeriod = (
    location,
    { selectedPeriod, selectedPmPeriod, selectedGaPeriod, selectedPeriodWithoutSummary },
) => {
    const { progressView } = getUrlParams(location);

    if (progressView) {
        switch (progressView) {
            case GROWTH_ANALYSIS:
                return selectedGaPeriod === BOY_EOY ? FULL_YEAR : selectedGaPeriod;
            case GOAL_SETTINGS:
                return getGoalSettingsPeriod(selectedPmPeriod);
            default:
                return selectedPmPeriod;
        }
    }

    return getReportPeriod(location, {
        selectedPeriod,
        selectedPeriodWithoutSummary,
    });
};
